/* eslint-disable no-return-assign */
/* eslint-disable react/no-array-index-key */
/* eslint-disable import/no-unresolved */
import {
    Panel, Checkbox, Radio, SelectTable, Input, Tabs,
    Tab, Table,
} from 'appkit-react';
import {
    Row, Col, Dropdown, DropdownButton,
} from 'react-bootstrap';
import { useRef } from 'react';

import noDataImg from 'assets/images/no-data.svg';
import '../styles/reportItemCode.scss';

const formatNames = [
    {
        formatId: 1,
        formatLabel: 'XLSX',
        formatName: 'xlsx',
    }, {
        formatId: 2,
        formatLabel: 'CSV',
        formatName: 'csv',
    },
];

const getCrossValidatedReportsWithQtrs = (id, name, quarters, checked, onChangeCheckbox) => {
    if (quarters.length > 0) {
        return quarters.map(({ label, period }) => (
            <Checkbox
                key={`${id}-${period}`}
                checked={checked}
                className="a-mb-20"
                onChange={(e, v) => onChangeCheckbox(e, id)}
            >
                {`${name} (${label})`}
            </Checkbox>
        ));
    }
    return null;
};

const getCrossValidatedReports = (selectedCrossReportsArray,
    onChangeCheckbox) => selectedCrossReportsArray && selectedCrossReportsArray.map(({
    id, name, quarters, checked,
}) => {
    if (quarters) {
        return getCrossValidatedReportsWithQtrs(id, name, quarters, checked, onChangeCheckbox);
    }
    return (
        <Checkbox
            key={id}
            checked={checked}
            onChange={(e, v) => onChangeCheckbox(e, id)}
            className="a-mb-20"
        >
            {name}
        </Checkbox>
    );
});

const getTabContent = (selectedItemCodeData, itemCodeMdrmColumns, itemCodeLoading) => (
    <>
        <div className="risk-detect-reg-reporting-cross-report-item-code-commonality_header">
            <p>
                <span style={{ fontWeight: 600 }}>Item Code Description : </span>
                {!itemCodeLoading && (
                    <span>{selectedItemCodeData?.itemDescription}</span>
                )}
            </p>
        </div>
        <div className="risk-detect-reg-reporting-cross-report-item-code-commonality_table">
            <Table
                data={itemCodeLoading ? [] : selectedItemCodeData?.mdrmDetails}
                columns={itemCodeMdrmColumns}
                sortable={false}
                showPagination={selectedItemCodeData?.mdrmDetails.length > 0}
                defaultPageSize={10}
                noDataText={(
                    <div style={{ padding: '1rem 2rem', textAlign: 'center' }}>
                        <img
                            src={noDataImg}
                            alt="No Data!!!"
                            style={{
                                width: '62.84px',
                                height: '62.82px',
                            }}
                        />
                    </div>
                )}
                loading={itemCodeLoading}
            />
        </div>
    </>
);

const ReportItemCode = ({
    selectedPrimaryReport, selectedCrossReportsArray, itemCodeArray, filterString,
    setFilterString, itemCodeColumns, selectAll, setSelectAll, selection,
    setSelection, activeTab, onChangeTab, tabDefinitions, selectedItemCodeData,
    itemCodeMdrmColumns, itemCodeLoading, downloadMdrmResultLoading, onSelectFileFormat,
    onChangeCheckbox, pageSizeOptions, pageSize,
}) => {
    let selectTable = useRef();
    const selectType = 'checkbox';
    const keyField = 'id';
    const toggleSelection = key => {
        let tempSelection = [...selection];
        const keyIndex = tempSelection.indexOf(key);
        if (keyIndex >= 0) {
            tempSelection = [
                ...tempSelection.slice(0, keyIndex),
                ...tempSelection.slice(keyIndex + 1),
            ];
        } else {
            tempSelection.push(key);
        }
        setSelection(tempSelection);
    };

    const toggleAll = () => {
        const tempSelectAll = !selectAll;
        const tempSelection = [];
        if (tempSelectAll) {
            const wrappedInstance = selectTable.getWrappedInstance();
            const currentRecords = wrappedInstance.getResolvedState().sortedData;
            currentRecords.forEach(item => {
                if (item._original) {
                    tempSelection.push(item._original.id);
                }
            });
        }
        setSelection(tempSelection);
        setSelectAll(tempSelectAll);
    };

    const isSelected = key => selection.includes(key);

    const extraProps = {
        selectAll,
        isSelected,
        toggleAll,
        toggleSelection,
        selectType,
        keyField,
    };

    const content = tabDefinitions.map((tab, index) => (
        <Tab
            id={tab.itemCode}
            value={tab.itemCode}
            icon={tab.itemCode}
            key={index}
        >
            {getTabContent(selectedItemCodeData, itemCodeMdrmColumns, itemCodeLoading)}
        </Tab>
    ));

    return (
        <Panel
            style={{ marginTop: '2rem' }}
        >
            <div className="risk-detect-reg-reporting-cross-report-item-code">
                <Row style={{ paddingTop: '1rem', paddingBottom: '1rem' }}>
                    <Col md={2}>
                        <Row>
                            <Col md={12}>
                                <div style={{ backgroundColor: '#F2F2F2', height: '450px' }}>
                                    <div
                                        className="risk-detect-reg-reporting-cross-report-item-code_header"
                                    >
                                        <h6>REPORTS</h6>
                                    </div>
                                    {(!selectedPrimaryReport || !selectedCrossReportsArray) && (
                                        <div style={{ padding: '1rem 1.5rem', textAlign: 'center' }}>
                                            <img
                                                src={noDataImg}
                                                alt="No Data!!!"
                                                style={{
                                                    width: '62.84px',
                                                    height: '62.82px',
                                                }}
                                            />
                                        </div>
                                    )}
                                    {selectedPrimaryReport && (
                                        <>
                                            <p style={{
                                                paddingLeft: '0.25rem', paddingTop: '1rem', fontSize: '0.875rem', fontWeight: 500, marginBottom: 0,
                                            }}
                                            >
                                                Primary Report
                                            </p>
                                            <div className="a-m-10">
                                                {!selectedPrimaryReport.primaryReportPeriod && (<Radio checked>{selectedPrimaryReport?.primaryReport?.name}</Radio>)}
                                                {selectedPrimaryReport.primaryReportPeriod && (
                                                    <Radio checked>{`${selectedPrimaryReport?.primaryReport?.name} (${selectedPrimaryReport?.primaryReportPeriod.label})`}</Radio>
                                                )}
                                            </div>
                                        </>
                                    )}
                                    {selectedCrossReportsArray.length > 0 && (
                                        <>
                                            <p style={{
                                                paddingLeft: '0.25rem', paddingTop: '0.25rem', fontSize: '0.875rem', fontWeight: 500,
                                            }}
                                            >
                                                Cross Validation Reports
                                            </p>
                                            <div
                                                style={{ display: 'flex', flexDirection: 'column', paddingLeft: '0.5rem' }}
                                                className="risk-detect-reg-reporting-cross-report-item-code_cross-report-div"
                                            >
                                                {
                                                    getCrossValidatedReports(selectedCrossReportsArray, onChangeCheckbox)
                                                }
                                            </div>
                                        </>
                                    )}
                                </div>
                            </Col>
                        </Row>
                    </Col>
                    <Col md={3}>
                        <Row>
                            <Col md={12}>
                                <div style={{ backgroundColor: '#F2F2F2', height: '450px' }}>
                                    <div
                                        className="risk-detect-reg-reporting-cross-report-item-code_header"
                                    >
                                        <h6>ITEM CODES</h6>
                                    </div>
                                    <div style={{ padding: '0.5rem' }}>
                                        <Input
                                            inputBoxSize="sm"
                                            prefix={<span className="appkiticon icon-search-outline baseline-search-icon change-color-with-focus" style={{ fontSize: 16 }} />}
                                            placeholder="Search here"
                                            value={filterString}
                                            onChange={e => setFilterString(e)}
                                        />
                                    </div>
                                    <div
                                        className="risk-detect-reg-reporting-cross-report-item-code_table"
                                    >
                                        <SelectTable
                                            data={itemCodeArray}
                                            ref={r => (selectTable = r)}
                                            columns={itemCodeColumns}
                                            showPagination={itemCodeArray.length > 0}
                                            showPageSizeOptions={false}
                                            defaultPageSize={pageSize}
                                            sortable={false}
                                            resizable={false}
                                            striped={false}
                                            pageSizeOptions={pageSizeOptions}
                                            noDataText={(
                                                <div style={{ padding: '1rem 2rem', textAlign: 'center' }}>
                                                    <img
                                                        src={noDataImg}
                                                        alt="No Data!!!"
                                                        style={{
                                                            width: '62.84px',
                                                            height: '62.82px',
                                                        }}
                                                    />
                                                </div>
                                            )}
                                            getTrProps={() => ({
                                                className: 'a-file-explorer-row-color',
                                            })}
                                            getTheadProps={() => ({
                                                className: 'a-apply-theme-background-gray-level-1',
                                            })}
                                            // eslint-disable-next-line react/jsx-props-no-spreading
                                            {...extraProps}
                                        />
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                    <Col md={7}>
                        <Row>
                            <Col>
                                <div
                                    className="risk-detect-reg-reporting-cross-report-item-code_header"
                                >
                                    <h6>CROSS REPORT COMPARISON</h6>
                                </div>
                                <div className="tabs-wrapper">
                                    <Tabs
                                        className="a-tab-item-padding-10"
                                        defaultValue={activeTab}
                                        value={activeTab}
                                        onChange={onChangeTab}
                                        size="md"
                                    >
                                        {content}
                                    </Tabs>
                                </div>
                                <div className="risk-detect-reg-reporting-cross-report-item-code-commonality">
                                    <div
                                        className="risk-detect-reg-reporting-cross-report-item-code_header__icons-section"
                                    >
                                        {downloadMdrmResultLoading
                                        && (
                                            <>
                                                <span className="a-loading a-primary a-m-10" style={{ width: '0.75rem', height: '.75rem' }} />
                                                <span style={{ marginRight: '2rem' }}>Downloading...</span>
                                            </>
                                        )}
                                        <div className="risk-detect-reg-reporting-cross-report-item-code-commonality__dropdown-button">
                                            <DropdownButton
                                                drop="down"
                                                variant="secondary"
                                                disabled={selectedItemCodeData === null || itemCodeLoading}
                                                title="Download MDRM Result"
                                            >
                                                {formatNames.map(({ formatId, formatName, formatLabel }) => (
                                                    <Dropdown.Item
                                                        key={formatId}
                                                        style={{ fontSize: '0.9rem' }}
                                                        onClick={
                                                            () => {
                                                                onSelectFileFormat(formatName);
                                                            }
                                                        }
                                                    >
                                                        {formatLabel}
                                                    </Dropdown.Item>
                                                ))}
                                            </DropdownButton>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </div>
        </Panel>
    );
};

export default ReportItemCode;
